import React from 'react';
import RevellerRealDataTable from '@/components/tables/RevellerRealDataTable';
import { useAuth } from '@/contexts/AuthContext';

interface RevellerPageProps {
  onNavigate: (view: string) => void;
}

const RevellerPage: React.FC<RevellerPageProps> = ({ onNavigate }) => {
  const { currentUser } = useAuth();

  return (
    <div className="space-y-8 animate-in fade-in">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white mb-1">Reveller Dashboard</h1>
        <button
          onClick={() => onNavigate('dashboard')}
          className="bg-kala-secondary hover:bg-cyan-400 text-kala-900 font-bold py-2 px-4 rounded"
        >
          Back to Dashboard
        </button>
      </div>
      <div id="reveller-tables" className="grid grid-cols-1 gap-8 mt-8">
        {currentUser ? (
            <RevellerRealDataTable currentUserRole={currentUser.role} currentUserId={currentUser.id} />
        ) : (
            <p>Loading user data...</p>
        )}
      </div>
    </div>
  );
};

export default RevellerPage;
